module.exports = __webpack_public_path__ + "static/media/value.64f7315b.svg";